import unauthenticatedHttp from "@/services/unauthenticatedHttp";
import { z } from "zod";

export async function subscriptions() {
  const { data } = await unauthenticatedHttp().get(
    `${window.env.UNAUTH_API}/subscriptions`
  );

  return data;
}

const offersData = z.object({
  active: z.boolean(),
  promotionStartTime: z.string(),
  productIds: z.array(z.string()),
  description: z.string(),
});

export async function unAuthFeaturedOffers() {
  const { data } = await unauthenticatedHttp().get(
    `${window.env.UNAUTH_API}/featured-offers`
  );
  if (!data) {
    return;
  }
  return offersData.parse(data);
}
